import consumer from "./consumer";

document.addEventListener('turbolinks:load', () => {
  const globalStatusDiv = document.getElementById('global-task-generation-status');

  const updateGlobalStatus = () => {
    if (globalStatusDiv) {
      const status = localStorage.getItem('taskGenerationStatus');
      let data = globalStatusDiv.dataset
      if (status === 'generating') {
        globalStatusDiv.textContent = data.generatingMessage;
        globalStatusDiv.classList.remove('failed');
        globalStatusDiv.classList.add('block');

        setTimeout(() => {
          globalStatusDiv.classList.remove('block');
          localStorage.setItem('taskGenerationStatus', 'generating_ongoing')
        }, 3000);
      } else {
        globalStatusDiv.classList.remove('block');
      }
    }
  };

  updateGlobalStatus();

  consumer.subscriptions.create({ channel: "TaskGenerationChannel" }, {
    connected() {
      console.log("Connected to TaskGenerationChannel.");
    },

    disconnected() {
      console.log("Disconnected from TaskGenerationChannel.");
    },

    received(data) {
      if (data.process_template_id !== undefined && data.process_template_id !== null) {
        const currentProcessTemplateElement = document.querySelector('[data-process-template-id]');
        let currentProcessTemplateId = currentProcessTemplateElement?.dataset?.processTemplateId;
        
        if (!currentProcessTemplateId) {
          const urlMatch = window.location.pathname.match(/\/process_templates\/(\d+)/);
          if (urlMatch) {
            currentProcessTemplateId = urlMatch[1];
          }
        }
        
        if (!currentProcessTemplateId || String(currentProcessTemplateId) !== String(data.process_template_id)) {
          return;
        }
      }

      if (data.status === 'completed') {
        localStorage.setItem('taskGenerationStatus', 'completed');

        // Store the generated text in localStorage
        if (data.generated_text && data.task_id && data.task_block_id) {
          localStorage.setItem(`trix-content-${data.task_id}-rich_text_input-${data.task_block_id}`, data.generated_text);
        }

        // Update task completion checkbox in real-time
        if (data.checkbox_html) {
          const containerSelector = `#dependency_checkbox_${data.task_id}`;
          const container = document.querySelector(containerSelector);

          if (container) {
            container.innerHTML = data.checkbox_html;
          } else {
            console.warn("Checkbox container NOT found:", containerSelector);
          }
        }

        // Update credit balance in real-time
        if (data.available_credits !== undefined) {
          this.updateCreditBalance(data.available_credits);
        }

        if (data.ai_process_generator) {
          window.location.reload();
        }

        const projectElement = document.querySelector('[data-project-id]');
        if (projectElement) {
          const submitButton = document.getElementById('generate-tasks-form')?.querySelector('input[type="submit"]');
          if (submitButton) {
            submitButton.disabled = false;
          }
          let block_element = document.querySelector(`.ai-content-${data.task_block_id}`)
          if (block_element && block_element.querySelector('.ai_description_block')) {
            block_element.querySelector('.ai_description_block').innerHTML = data.generated_text
          }
        }
      } else if (data.status === 'failed') {
        localStorage.setItem('taskGenerationStatus', 'failed');
        
        // Show error message if provided
        if (data.error) {
          this.showError(data.error);
        }
      } else if (data.status === 'generating') {
        localStorage.setItem('taskGenerationStatus', 'generating');
      }

      updateGlobalStatus();
    },

    updateCreditBalance(availableCredits) {
      // Update credit balance display in real-time
      const creditBalanceElements = document.querySelectorAll('[data-credit-balance]');
      creditBalanceElements.forEach(element => {
        element.textContent = `${availableCredits} credits`;
      });
      
      // Update credit balance in credit display components
      const creditDisplayElements = document.querySelectorAll('.credit-balance-amount');
      creditDisplayElements.forEach(element => {
        element.textContent = `${availableCredits} credits`;
      });

      // Update credit balance in AI text generator components
      const aiCreditElements = document.querySelectorAll('.ai-credit-balance');
      aiCreditElements.forEach(element => {
        element.textContent = `${availableCredits} credits`;
      });
    },

    showError(message) {
      // Show error message in a user-friendly way
      const errorDiv = document.createElement('div');
      errorDiv.className = 'alert alert-danger';
      errorDiv.style.cssText = 'position: fixed; top: 20px; right: 20px; z-index: 9999; max-width: 400px;';
      errorDiv.innerHTML = `
        <div style="display: flex; align-items: center; gap: 10px;">
          <span style="color: #dc3545;">⚠️</span>
          <span>${message}</span>
          <button onclick="this.parentElement.parentElement.remove()" style="background: none; border: none; color: #dc3545; font-size: 18px; cursor: pointer;">&times;</button>
        </div>
      `;
      
      document.body.appendChild(errorDiv);
      
      // Auto-remove after 5 seconds
      setTimeout(() => {
        if (errorDiv.parentElement) {
          errorDiv.remove();
        }
      }, 5000);
    }
  });
});
